import React from 'react'
import ReactDOM from 'react-dom/client'
import posthog from 'posthog-js'
import { HeroUIProvider } from '@heroui/react'
import App from './App.tsx'
import './index.css'
import { ThemeProvider } from './contexts/ThemeContext'

if (import.meta.env.VITE_PUBLIC_POSTHOG_KEY) {
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    person_profiles: 'identified_only',
  })
}

// Automatically recover from stale chunk hashes after a new production deployment
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  const reloadKey = 'pos:chunk-reload-attempted'
  if (!sessionStorage.getItem(reloadKey)) {
    sessionStorage.setItem(reloadKey, '1')
    window.location.reload()
  }
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <HeroUIProvider>
        <App />
      </HeroUIProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
